import * as React from "react";
import Svg, { SvgProps, Circle, Path } from "react-native-svg";
const SvgComponent = (props: SvgProps) => (
  <Svg width={62} height={62} fill="none" {...props}>
    <Circle cx={31} cy={31} r={30.5} stroke="#FDFBF9" />
    <Path
      fill="#FDFBF9"
      d="m28.565 36.215-4.861-4.861.664-.664 4.197 4.206 9.076-9.076.655.665-9.73 9.73Z"
    />
  </Svg>
);
export default SvgComponent;
